import { render } from "./vue-chapter-2.vue?vue&type=template&id=91f99ed6"
import script from "./vue-chapter-2.vue?vue&type=script&lang=js"
export * from "./vue-chapter-2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__